



















































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { GrowingPurpose } from '@/models/student/growing-purpose';
import { GroupSetting } from '@/models/school-group/group-setting';
import { masterModule } from '@/store/modules/entities/master.module';
import { groupModule } from '@/store/modules/entities/group.module';
import { GroupType } from '@/constants/groupType.enum';
import { CustomCompetency } from '@/models/competency/competency';
import { customCompetencyModule } from '@/store/modules/frames/custom-competency.module';
import { SchoolGroupGrowingPurpose } from '@/models/school-group/school-group-growing-purpose';

@Component({
  name: 'GClassManagementGroupingProposalConfirm',
  computed: {},
  methods: {},
})
export default class GClassManagementGroupingProposalConfirm extends mixins(GPageBase) {
  mounted() {}

  growingPurposeTitle(groupSetting: GroupSetting) {
    // 学校コンピテンシーが設定されている
    if (groupSetting.schoolCompetencyID > 0) {
      return this.validGrowingPurposesAndSchoolCompetencies.find((sgrgp: SchoolGroupGrowingPurpose) => {
        if (sgrgp.isSchoolCompetency && sgrgp.growingPurposeID == groupSetting.schoolCompetencyID) {
          return sgrgp;
        }
      }).title;
    } else {
      return this.validGrowingPurposesAndSchoolCompetencies.find((sgrgp: SchoolGroupGrowingPurpose) => {
        if (!sgrgp.isSchoolCompetency && sgrgp.growingPurposeID == groupSetting.purposeOfTraining) {
          return sgrgp;
        }
      }).title;
    }
  }

  get groupSetting(): GroupSetting {
    return groupModule.groupSetting;
  }

  get growingPurposes(): GrowingPurpose[] {
    return masterModule.growingPurposes;
  }


  get validGrowingPurposesAndSchoolCompetencies(): SchoolGroupGrowingPurpose[] {
    var count = 0;
    const growingPurposes: SchoolGroupGrowingPurpose[] = masterModule.validGrowingPurposes.map((gp: GrowingPurpose) => {
        count++;
        return {
          tmpID: count,
          growingPurposeID: gp.growingPurposeID,
          title: gp.title,
          isSchoolCompetency: false,
        } as SchoolGroupGrowingPurpose;
      });
    // 学校コンピテンシーが存在すれば、それを「育成目的」（GrowingPurpose）として扱う
    
    var customCompetencies: SchoolGroupGrowingPurpose[] = [];
    if (this.customCompetencies.length > 0) {
      customCompetencies = this.customCompetencies.map((cComp) => {
        count++;
        return {
          tmpID: count,
          growingPurposeID: cComp.id,
          title: cComp.name,
          isSchoolCompetency: true,
        } as SchoolGroupGrowingPurpose;
      });
    }
    return growingPurposes.concat(customCompetencies);
  }

  get customCompetencies(): CustomCompetency[] {
    return customCompetencyModule.customCompetencies;
  }

  groupTypeName(groupType: number): string {
    return GroupType.groupTypeName(groupType);
  }
}
